<template>
  <CFooter :fixed="false" class="app-footer">
      <span>&copy; {{new Date().getFullYear()}} - Powered by Center for Information Technology Services
</span>
  
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>

<style scoped>
.app-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 54px;
  padding: 12px 16px;
  color: #766b6b;
  text-align: center;
  border: 0 !important;
}

@media (max-width: 767px) {
  .app-footer {
    min-height: 64px;
    padding: 14px 18px 18px;
    font-size: 0.72rem;
    line-height: 1.45;
  }

  .app-footer span {
    display: block;
    width: 100%;
    text-align: center;
  }
}
</style>
